import React from 'react';
import { motion } from 'framer-motion';
import { Info } from 'lucide-react';
export function DidYouKnow() {
  return <section className="w-full py-16 px-4" data-id="element-49">
      <div className="max-w-3xl mx-auto" data-id="element-50">
        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} className="bg-forest text-cream-card p-8 md:p-10 rounded-2xl shadow-xl relative overflow-hidden" data-id="element-51">
          {/* Decorative background elements */}
          <div className="absolute -right-10 -top-10 opacity-10" data-id="element-52">
            <Info className="w-48 h-48" data-id="element-53" />
          </div>

          <h2 className="font-handwriting text-4xl font-bold mb-8 text-center relative z-10" data-id="element-54">
            Wusstest du das?
          </h2>

          <ul className="space-y-6 font-serif text-lg relative z-10" data-id="element-55">
            <li className="flex items-start gap-4" data-id="element-56">
              <div className="w-2 h-2 rounded-full bg-cream mt-2.5 flex-shrink-0" data-id="element-57" />
              <p data-id="element-58">
                Ein gesunder Hund verdaut innerhalb von{' '}
                <strong data-id="element-59">8-10 Stunden</strong>.
              </p>
            </li>
            <li className="flex items-start gap-4" data-id="element-60">
              <div className="w-2 h-2 rounded-full bg-cream mt-2.5 flex-shrink-0" data-id="element-61" />
              <p data-id="element-62">
                <strong data-id="element-63">Ballaststoffmangel</strong> ist einer der häufigsten
                Gründe für eine träge Verdauung beim Hund.
              </p>
            </li>
            <li className="flex items-start gap-4" data-id="element-64">
              <div className="w-2 h-2 rounded-full bg-cream mt-2.5 flex-shrink-0" data-id="element-65" />
              <p data-id="element-66">
                Lösliche Ballaststoffe können die Darmpassagezeit um{' '}
                <strong data-id="element-67">bis zu 40% verbessern</strong>.
              </p>
            </li>
          </ul>
        </motion.div>
      </div>
    </section>;
}